import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icona-fangxiangzhishiyoushuangjiantouyou",
  "use": "icon-icona-fangxiangzhishiyoushuangjiantouyou-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icona-fangxiangzhishiyoushuangjiantouyou\"><path d=\"M261.696 810.496L560.32 511.808 261.76 213.12l-54.336 54.336 244.352 244.352L207.424 756.16l54.336 54.336zm256 0L816.32 511.808 517.76 213.12l-54.336 54.336 244.352 244.352L463.424 756.16l54.336 54.336z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol